export default class Setting {
    constructor(dto) {
        // Regional Settings
        this.defaultDateFormat = ''
        this.defaultDecimalSeparator = ''
        this.defaultThousandSeparator = ''
        this.defaultLanguageId = ''
        this.defaultTimezone = ''

        // Security
        this.enablePasswordExpiration = false
        this.passwordExpirationDays = ''
        this.enableAccountInactivity = false
        this.accountInactivityDays = ''
        this.enableFailedLoginAttempts = false
        this.failedLoginAttempts = ''
        this.enableTokenExpiration = true
        this.tokenExpirationMinutes = ''
        this.enablePasswordStrength = false
        this.passwordStrengthMinLength = ''
        this.passwordStrengthMaxLength = ''
        this.passwordStrengthSpecialLength = ''
        this.passwordStrengthUpperLength = ''
        this.passwordStrengthNumberLength = ''

        // Search
        this.searchResultsOrderAsc = false
        this.searchResultsVisibleFields = 0
        this.maxSearchResults = 0
        this.enableDocumentPreAuthorization = false

        // Email
        this.emailAccount = ''
        this.emailPassword = ''
        this.emailServer = ''
        this.emailPort = ''
        this.emailUseSSL = false
        this.sendGridApiKey = ''

        //DocuSign
        this.docuSignEnabled = false;
        this.docuSignAccountID = "";
        this.docuSignApiURL = "";
        this.docuSignIntegrationKey = "";
        this.docuSignRSAKey = "";

        // Two factor authentication
        this.twoFactorAuthenticationServiceId = ''
        this.twoFactorAuthenticationAuthApiKey = ''

        if (dto) {
            // Regional Settings
            this.defaultDateFormat = dto.DefaultDateFormat
            this.defaultDecimalSeparator = dto.DefaultDecimalSeparator
            this.defaultThousandSeparator = dto.DefaultThousandSeparator
            this.defaultLanguageId = dto.DefaultLanguageID + ''
            this.defaultTimezone = dto.DefaultTimezone

            // Security
            this.enablePasswordExpiration = dto.EnablePasswordExpiration
            if (dto.EnablePasswordExpiration) {
                this.passwordExpirationDays = dto.PasswordExpirationDays
            }
            this.enableAccountInactivity = dto.EnableAccountInactivity
            if (dto.EnableAccountInactivity) {
                this.accountInactivityDays = dto.AccountInactivityDays
            }
            this.enableFailedLoginAttempts = dto.EnableFailedLoginAttempts
            if (dto.EnableFailedLoginAttempts) {
                this.failedLoginAttempts = dto.FailedLoginAttempts
            }
            this.tokenExpirationMinutes = dto.TokenExpirationMinutes
            this.enablePasswordStrength = dto.EnablePasswordStrength
            if (dto.EnablePasswordStrength) {
                this.passwordStrengthMinLength = dto.PasswordStrengthMinLength
                this.passwordStrengthMaxLength = dto.PasswordStrengthMaxLength
                this.passwordStrengthSpecialLength = dto.PasswordStrengthSpecialLength
                this.passwordStrengthUpperLength = dto.PasswordStrengthUpperLength
                this.passwordStrengthNumberLength = dto.PasswordStrengthNumberLength
            }

            // Search
            this.searchResultsOrderAsc = dto.SearchResultsOrderAsc
            this.searchResultsVisibleFields = dto.SearchResultsVisibleFields
            this.maxSearchResults = dto.MaxSearchResults
            this.enableDocumentPreAuthorization = dto.EnableDocumentPreAuthorization

            // Email
            this.emailAccount = dto.EmailAccount
            this.emailPassword = dto.EmailPassword
            this.emailServer = dto.EmailServer
            this.emailPort = dto.EmailPort
            this.emailUseSSL = dto.EmailUseSSL
            this.sendGridApiKey = dto.SendGridApiKey;

            //DocuSign
            this.docuSignAccountID = dto.DocuSignAccountID
            this.docuSignApiURL = dto.DocuSignApiURL
            this.docuSignIntegrationKey = dto.DocuSignIntegrationKey
            this.docuSignRSAKey = dto.DocuSignRSAKey
            this.docuSignEnabled = (this.docuSignAccountID && this.docuSignApiURL && this.docuSignIntegrationKey && this.docuSignRSAKey);

            // Two factor authentication
            this.twoFactorAuthenticationServiceId = dto.TwoFactorAuthenticationServiceId
            this.twoFactorAuthenticationAuthApiKey = dto.TwoFactorAuthenticationAuthApiKey
        }
    }

    toDto() {
        return {
            // Regional Settings
            DefaultDateFormat: this.defaultDateFormat,
            DefaultDecimalSeparator: this.defaultDecimalSeparator,
            DefaultThousandSeparator: this.defaultThousandSeparator,
            DefaultLanguageID: this.defaultLanguageId,
            DefaultTimezone: this.defaultTimezone,

            // Security
            EnablePasswordExpiration: this.enablePasswordExpiration,
            PasswordExpirationDays: this.passwordExpirationDays,
            EnableAccountInactivity: this.enableAccountInactivity,
            AccountInactivityDays: this.accountInactivityDays,
            EnableFailedLoginAttempts: this.enableFailedLoginAttempts,
            FailedLoginAttempts: this.failedLoginAttempts,
            EnableTokenExpiration: this.enableTokenExpiration,
            TokenExpirationMinutes: this.tokenExpirationMinutes,
            EnablePasswordStrength: this.enablePasswordStrength,
            PasswordStrengthMinLength: this.passwordStrengthMinLength,
            PasswordStrengthMaxLength: this.passwordStrengthMaxLength,
            PasswordStrengthSpecialLength: this.passwordStrengthSpecialLength,
            PasswordStrengthUpperLength: this.passwordStrengthUpperLength,
            PasswordStrengthNumberLength: this.passwordStrengthNumberLength,

            // Search
            MaxSearchResults: this.maxSearchResults,
            SearchResultsOrderAsc: this.searchResultsOrderAsc,
            SearchResultsVisibleFields: this.searchResultsVisibleFields,
            EnableDocumentPreAuthorization: this.enableDocumentPreAuthorization,

            // Email
            EmailAccount: this.emailAccount,
            EmailPassword: this.emailPassword,
            EmailServer: this.emailServer,
            EmailPort: this.emailPort,
            EmailUseSSL: this.emailUseSSL,
            SendGridApiKey: this.sendGridApiKey,

            //DocuSign
            DocuSignAccountID: (this.docuSignEnabled ? this.docuSignAccountID : "" ),
            DocuSignApiURL: (this.docuSignEnabled ? this.docuSignApiURL : "" ),
            DocuSignIntegrationKey: (this.docuSignEnabled ? this.docuSignIntegrationKey : ""),
            DocuSignRSAKey: (this.docuSignEnabled ? this.docuSignRSAKey : "") ,

            // Two Factor authentication
            TwoFactorAuthenticationServiceId: this.twoFactorAuthenticationServiceId,
            TwoFactorAuthenticationAuthApiKey: this.twoFactorAuthenticationAuthApiKey,
        }
    }
}
